import ValidateRut from 'helpers/validateRut';
import * as yup from 'yup';

const SchemaGenerador = yup.object().shape({
  rutEmpresaGenerador: yup // Integer (max 12), obligatorio
    .string()
    .trim()
    .matches(/^[^.\s]*$/, 'No se permiten puntos en este campo')
    .max(12, 'La cantidad máxima de caracteres es 11')
    .min(9, 'La cantidad mínima de caracteres es 9')
    .matches(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/, 'Formato inválido (XXXXXXXX-X)')
    .test(
      'Evaluación de rut',
      'El rut ingresado es inválido',
      value => !value || ValidateRut.isValid(value)
    )
    .required('Este campo es obligatorio'),

  nombreEmpresaGenerador: yup
    .string()
    .trim()
    .max(128, 'La cantidad máxima de caracteres es 128')
    .min(2, 'La cantidad mínima de caracteres es 2')
    .required('Este campo es obligatorio')
});

export { SchemaGenerador };
